export default __webpack_public_path__ + "static/media/winner2.c5b02ca9.jpg";